import flatpickr from "flatpickr";


var location_selection = 0;
var calendar = null;
var time_pickr = null;

const update_time_help_text = function(val) {
  return;
  location_selection = val;
  if(val == 'Genf' || val == 'Bern') {
    $(".appointment-form #id_time + span").html(window.DATE_RANGES_TXT[0]);
  } else {
    $(".appointment-form #id_time + span").html(window.DATE_RANGES_TXT[1]);
  }
};

const initTimePicker = () => {
  const val = $(".appointment-form #id_time").flatpickr({
    enableTime: true,
    noCalendar: true,
    time_24hr: true,
    locale: window.LANGUAGE_CODE,
    minuteIncrement: 30,
    dateFormat: "H:i",
    onValueUpdate: function(date, time, time_pickr) {
      const new_date = date[0];
      const hour = new_date.getHours();
      let day = -1;
      if (calendar.selectedDates.length) {
        day = calendar.selectedDates[0].getDay();
      }
      if (location_selection === 'Zürich Löwenbräu') {
        if (day === 6) {
          if (hour > 16) {
            new_date.setHours(16);
            time_pickr.setDate(new_date);
          } else if (hour < 10) {
            new_date.setHours(10);
            time_pickr.setDate(new_date);
          }
        } else {
          if (hour > 18) {
            new_date.setHours(18);
            time_pickr.setDate(new_date);
          } else if (hour < 11) {
            new_date.setHours(11);
            time_pickr.setDate(new_date);
          }
        }

      } else if (location_selection === 'Zürich Tiefenbrunnen') {
        if (hour < 10) {
          new_date.setHours(10);
          time_pickr.setDate(new_date);
        }
        if (day === 6) {
          if (hour > 16) {
            new_date.setHours(16);
            time_pickr.setDate(new_date);
          }
        } else {
          if (hour > 18) {
            new_date.setHours(18);
            time_pickr.setDate(new_date);
          }
        }

      } else if (location_selection === 'Genf') {
        if (day === 6) {
          if (hour < 9) {
            new_date.setHours(9);
            time_pickr.setDate(new_date);
          }
          if (hour > 16) {
            new_date.setHours(16);
            time_pickr.setDate(new_date);
          }
        } else {
          if (hour < 13) {
            new_date.setHours(13);
            time_pickr.setDate(new_date);
          }
          if (hour > 17) {
            new_date.setHours(17);
            time_pickr.setDate(new_date);
          }
        }
      } else {
        if (day === 6) {
          if (hour < 10) {
            new_date.setHours(10);
            time_pickr.setDate(new_date);
          } else if (hour > 15) {
            new_date.setHours(15);
            time_pickr.setDate(new_date);
          }
        } else {
          if (hour < 10) {
            new_date.setHours(10);
            time_pickr.setDate(new_date);
          } else if (hour > 17) {
            new_date.setHours(17);
            time_pickr.setDate(new_date);
          }
        }
      }
    }
  });
  return val;
};

const init_calendar = function() {
  calendar = $(".appointment-form #id_date").flatpickr({
      dateFormat: "d.m.Y",
      locale: window.LANGUAGE_CODE,
      disable: [
          function(date) {
            if (location_selection === 'Zürich Löwenbräu') {
              return (date.getDay() === 2 || date.getDay() === 1 || date.getDay() === 0);
            } else if (location_selection === 'Zürich Tiefenbrunnen') {
              return (date.getDay() === 0);
            } else if (location_selection === 'Bern') {
              return (date.getDay() === 1 || date.getDay() === 0);
            } else {
              return (date.getDay() === 0 || date.getDay() === 1);
            }
          }
      ],
    });
};

$(window).on('form-modal:opened', function() {
  init_calendar();
  update_time_help_text($(".appointment-form #id_office").val());
  $(".appointment-form #id_office").change(function () {
    location_selection = $(this).val();
    update_time_help_text($(this).val());
    // reset_time_pickr();
    time_pickr = initTimePicker();

    init_calendar();
  });

  time_pickr = initTimePicker();

  const reset_time_pickr = function () {
    const date = new Date();
    date.setMinutes(0);

    if (location_selection === 'Genf' || location_selection === 'Bern') {
      date.setHours(9);
      time_pickr.setDate(date);
    } else {
      date.setHours(10);
      time_pickr.setDate(date);
    }
  }
});



// WEBPACK FOOTER //
// ./static/js/modules/appointment_picker.js